module.exports = __webpack_public_path__ + "static/media/color_logo_transparent.f48036ab.png";